// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfflineStatus__container-c53678 {
  text-align: left;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  display: inline-flex;
  align-items: center;
}

.OfflineStatus__loader-ac9d57 {
  width: 14px;
  height: 14px;
  margin-inline-end: 6px;
  position: relative;
  bottom: -1px;
}
.OfflineStatus__loader-ac9d57 stop {
  stop-color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/components/OfflineStatus/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EAEA,oBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAAF;AAEE;EACE,0BAAA;AAAJ","sourcesContent":[".container {\n  text-align: left;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n\n  display: inline-flex;\n  align-items: center;\n}\n\n.loader {\n  width: 14px;\n  height: 14px;\n  margin-inline-end: 6px;\n  position: relative;\n  bottom: -1px;\n\n  & stop {\n    stop-color: var(--base-80);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OfflineStatus__container-c53678`,
	"loader": `OfflineStatus__loader-ac9d57`
};
module.exports = ___CSS_LOADER_EXPORT___;
